export default __webpack_public_path__ + "static/media/footer-cap-mesh.48150e88.png";